<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">Organization Base Calendar</p>
      </div>

      <div class="px-2 pb-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="create_success"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>

        <div>
          <el-calendar v-model="value" :first-day-of-week="1">
            <template slot="dateCell" slot-scope="{ date, data }">
              <div
                :class="isHoliday(data.isSelected, date) ? 'is-holiday' : ''"
                class="relative"
              >
                <el-popover
                  v-if="isHoliday(data.isSelected, date)"
                  placement="top-start"
                  :title="getHolidayName(date)"
                  width="200"
                  trigger="hover"
                >
                  <p>{{ getHolidayDescription(date) }}</p>
                  <!-- <el-button class="info-btn"> -->
                  <i slot="reference" class="el-icon-info"></i>
                  <!-- </el-button> -->
                </el-popover>
                {{ data.day.split("-")[2] }}
                {{ getHolidayName(date) }}
              </div>
            </template>
          </el-calendar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
// configure language
locale.use(lang);
// import Switches from 'vue-switches';
export default {
  name: "timeOffBaseCalendar",
  components: { Loader },

  data() {
    return {
      value: "",
      newDHolidaydates: "",
      del_error: null,
      create_success: null,
      get_error: null,
      searchInput: "",
      loading: false,
      holidays: [],
      dateFormat: "MMMM yyyy",
      newHolidayDates: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  created() {
    this.getHolidays();
  },
  methods: {
    // Mark holidays
    isHoliday(data, date) {
      // console.log(data, date);
      // Convert date to ISO format for comparison
      date.setDate(date.getDate());
      const isoDate = date.toISOString().substring(0, 10);

      // Check if holidays array contains a holiday with the same ISO date
      return this.holidays.some(
        (holiday) =>
          new Date(holiday.ISO).toISOString().substring(0, 10) === isoDate
      );
    },

    //     isHoliday(data, date) {
    //   // Convert both dates to UTC before comparison
    //   const dateUTC = new Date(
    //     Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    //   );

    //   return this.holidays.some((holiday) => {
    //     const holidayDate = new Date(
    //       Date.UTC(
    //         holiday.year, // Replace with the holiday's year field
    //         holiday.month - 1, // JavaScript months are 0-indexed, adjust if necessary
    //         holiday.day
    //       )
    //     );
    //     return dateUTC.getTime() === holidayDate.getTime();
    //   });
    // }

    getHolidayDescription(date) {
      const isoDate = date.toISOString().substring(0, 10);

      return this.holidays.find(
        (holiday) =>
          new Date(holiday.ISO).toISOString().substring(0, 10) === isoDate
      )?.Description;
    },
    getHolidayName(date) {
      const isoDate = date.toISOString().substring(0, 10);

      return this.holidays.find(
        (holiday) =>
          new Date(holiday.ISO).toISOString().substring(0, 10) === isoDate
      )?.Name;
    },
    // /{organization}/holiday/v1/request
    getHolidays() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/holiday/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.holidays = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // Add new holidays
    addNewHolidays() {
      this.newHolidayDates.forEach((date) => {
        const holiday = this.holidays.find(
          (holiday) => holiday.date.getTime() === date.getTime()
        );
        if (!holiday) {
          const newHoliday = {
            date,
            description: "",
          };
          this.holidays.push(newHoliday);
        }
      });
      this.newHolidayDates = [];
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}

.is-holiday {
  color: #1989fa;
  /* background-color: yellow; */
  cursor: pointer;
}

.info-btn {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 1;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: transparent;
  color: #67c23a;
  font-size: 14px;
  line-height: 1.5;
  transition: all 0.3s ease-in-out;
}

.info-btn:hover {
  cursor: pointer;
  transform: scale(1.2);
}
</style>
